export default "__VITE_ASSET__Dn8KeC06__";